import { ApolloLink } from '@apollo/client';
import { map } from 'rxjs';

/** Logs development operations while keeping one-time API credentials out of the console. */
export const apolloLogger = new ApolloLink((operation, forward) => {
  if (operation.operationName === 'CreateBlinqApiKey') {
    return forward(operation);
  }

  const startTime = Date.now();
  return forward(operation).pipe(
    map((result) => {
      const elapsed = Date.now() - startTime;
      const group = [`[GraphQL ${operation.operationName}] (${elapsed}ms)`];
      console.groupCollapsed(...group);
      console.log('INIT', operation);
      console.log('RESULT', result);
      console.groupEnd();
      return result;
    }),
  );
});
